<template>
  <div id="award-type-list">
    <v-overlay :value="OverlayLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card
      class="rounded-xl elevation-4 border-0"
      style="background-color: #ffffff; overflow: hidden"
    >
      <v-form
        ref="form1"
        v-model="valid1"
        lazy-validation
        v-on:submit.prevent="searchForm"
      >
        <!-- Header -->
        <v-card-title
          class="px-6 py-4 d-flex justify-space-between align-center"
          style="background-color: #3a67b1"
        >
          <div class="d-flex align-center">
            <v-icon color="#EDBE38" class="mr-3" size="28"
              >mdi-file-document-edit</v-icon
            >
            <span class="text-h6 font-weight-bold" style="color: #ffffff">{{
              PageTitle
            }}</span>
          </div>
          <v-btn icon @click="closePrompt" class="ma-0">
            <v-icon color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </div>

          <!-- Read-only Details -->
          <v-container
            v-if="recordData.YearwiseMembershipId != ''"
            class="pa-0 mb-6"
          >
            <!-- Member Photo -->
            <v-row v-if="recordData.MemberImagePath != ''">
              <v-col cols="12" class="d-flex justify-center mb-4">
                <v-avatar
                  size="100"
                  class="elevation-2"
                  style="border: 3px solid #3a67b1"
                >
                  <v-img
                    :src="recordData.MemberImagePath"
                    :alt="recordData.MemberName"
                    lazy-src="/no-image-available.png"
                  ></v-img>
                </v-avatar>
              </v-col>
            </v-row>

            <div
              class="rounded-xl pa-5"
              style="
                background-color: rgba(58, 103, 177, 0.03);
                border: 1px solid rgba(58, 103, 177, 0.1);
              "
            >
              <h5
                class="mb-4 font-weight-bold d-flex align-center"
                style="color: #3a67b1; font-size: 16px"
              >
                <v-icon color="#EDBE38" class="mr-2" size="22"
                  >mdi-account-details-outline</v-icon
                >
                Member Overview
              </h5>
              <v-row>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #0097d7;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-identifier</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Membership Id</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.MembershipId || "NA" }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #0097d7;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-account</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Member Name</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.MemberName || "NA" }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #0097d7;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-phone</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Mobile No</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.MobileNo || "NA" }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #0097d7;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-email</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Email Id</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.EmailId || "NA" }}
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="6" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #3a67b1;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-map-marker-radius</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Address</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.AddressTxt || "NA" }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #3a67b1;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-map</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Current Zone</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.ZoneName || "NA" }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #3a67b1;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-home-city</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Current LO</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.LomName || "NA" }}
                    </div>
                  </div>
                </v-col>

                <!-- Payment Info -->
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #56bda3;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-credit-card</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Payment Id</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.PaymentRzrId || "NA" }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #56bda3;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-tag</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Payment Type</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.OrderTypeTxt || "NA" }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #56bda3;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-calendar</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Paid Date</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.PaidDateTxt || "NA" }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-2">
                  <div
                    class="pa-3 rounded-lg elevation-1"
                    style="
                      background-color: #ffffff;
                      height: 100%;
                      border-left: 3px solid #56bda3;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon color="#414042" size="14" class="mr-1"
                        >mdi-cash</v-icon
                      >
                      <span
                        style="
                          color: #414042;
                          font-size: 12px;
                          font-weight: 500;
                          text-transform: uppercase;
                        "
                        >Paid Amount</span
                      >
                    </div>
                    <div
                      style="color: #0a0f29; font-size: 15px; font-weight: 700"
                    >
                      {{ recordData.DepositedAmount || "0" }}
                      <span
                        v-if="recordData.PaymentMode"
                        style="font-weight: 500; color: #414042"
                        >({{ recordData.PaymentMode }})</span
                      >
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>

          <!-- Form Fields -->
          <v-container class="pa-0">
            <h5
              class="mb-4 font-weight-bold"
              style="
                color: #3a67b1;
                font-size: 18px;
                border-bottom: 2px solid #edbe38;
                display: inline-block;
                padding-bottom: 4px;
              "
            >
              Update LO Details
            </h5>
            <v-row justify="center">
              <v-col cols="12" sm="5" md="4">
                <div
                  class="mb-2"
                  style="color: #0a0f29; font-weight: 600; font-size: 15px"
                >
                  Zone <span style="color: #0097d7">*</span>
                </div>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :items="ZoneCodeOptions"
                  :rules="ZoneCodeRules"
                  :loading="ZoneCodeOptionsLoading"
                  v-model="ZoneCode"
                  dense
                  clearable
                  required
                  outlined
                  background-color="#FFFFFF"
                  color="#0097D7"
                  class="rounded-lg"
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="5" md="4">
                <div
                  class="mb-2"
                  style="color: #0a0f29; font-weight: 600; font-size: 15px"
                >
                  LO <span style="color: #0097d7">*</span>
                </div>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :items="LomCodeOptions"
                  :rules="LomCodeRules"
                  :loading="LomCodeOptionsLoading"
                  v-model="LomCode"
                  dense
                  clearable
                  required
                  outlined
                  background-color="#FFFFFF"
                  color="#0097D7"
                  class="rounded-lg"
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Footer -->
        <v-divider style="border-color: rgba(65, 64, 66, 0.1)"></v-divider>
        <v-card-actions class="pa-6 pt-4 d-flex justify-end">
          <v-btn
            @click="closePrompt"
            elevation="0"
            outlined
            class="rounded-lg mr-3 font-weight-bold px-6"
            style="
              color: #414042;
              border-color: #414042;
              text-transform: none;
              height: 44px;
            "
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="!valid1"
            @click.prevent="confirmAlert"
            :loading="SubmitFlag"
            elevation="2"
            color="#56BDA3"
            class="rounded-lg font-weight-bold px-8"
            style="
              color: #ffffff;
              text-transform: none;
              height: 44px;
              letter-spacing: 0.5px;
            "
          >
            <v-icon left size="20" color="#FFFFFF"
              >mdi-check-circle-outline</v-icon
            >
            Update
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>
  
  <script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    editRecordPrompt: {
      required: true,
      type: Boolean,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      search: "",
      uploadPercentage: 0,
      SubmitFlag: false,
      SearchFlag: false,
      ResultFlag: false,

      OverlayLoadingFlag: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [(v) => !!v || "LO is required"],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      rows: [],

      PageInfo: {},
      PageTitle: "Edit Senior Member LO",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  computed: {},
  watch: {
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions called");
      this.LomCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch Zone called");
      this.LomCode = "";
      this.getLomCodeOptions();
    },
  },
  created() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;

      this.getZoneCodeOptions();
      console.log("recordData = " + JSON.stringify(this.recordData));
      this.LoadingFlag = false;
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideEditRecordPrompt", this.ResultFlag);
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var ZoneCode = this.ZoneCode;
      console.log({ ZoneCode });
      if (ZoneCode != "") {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        message += "Zone should not be empty. ";
      }
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#56BDA3",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#414042",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        // this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      var tr = this.recordData;
      console.log("tr = " + JSON.stringify(tr));

      if (validate1) {
        this.LoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/senior-members/lom-update";
        var upload = {
          UserInterface: 1,
          Member: tr.MemberId,
          YearwiseMembershipId: tr.YearwiseMembershipId,
          Zone: this.ZoneCode,
          Lom: this.LomCode,
          YearCode: tr.YearCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.sweetAlert("success", output, false);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
  
  <style lang="scss"></style>
  